import type {
	ProductImportResponse,
	ProductImportViolation,
	TemplateImportResponse,
	TemplateImportViolation,
} from '@api-client/api'
import { isAxiosError } from 'axios'
import { useCallback, useState } from 'react'

export const useBulkImportChangeFileCallback = (
	checkFile: (
		file: File
	) => Promise<ProductImportResponse | TemplateImportResponse>,
	deps: readonly unknown[]
) => {
	const [file, setFile] = useState<File | undefined>()
	const [isFileValid, setIsFileValid] = useState(false)
	const [violations, setViolations] = useState<
		readonly (TemplateImportViolation | ProductImportViolation)[] | undefined
	>()
	const handleFileChange = useCallback(async (file?: File) => {
		setFile(file)
		setIsFileValid(false)
		setViolations(undefined)
		if (!file) {
			return
		}
		try {
			const result = await checkFile(file)
			setViolations(result.violations)
		} catch (error: unknown) {
			if (
				error &&
				isAxiosError<ProductImportResponse | TemplateImportResponse>(error) &&
				(error.response?.status ?? 500) < 500
			) {
				setViolations(error.response?.data?.violations)
			}
			throw error
		}
		setIsFileValid(true)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps)
	return [file, isFileValid, violations, handleFileChange] as const
}
